const routeHasMeta = (route, key) => route.matched.some((record) => record.meta[key]);

export const isEmailVerified = (user) => Boolean(user && user.email_verified_at);

export const subscriptionRedirectPath = (user) => (isEmailVerified(user) ? '/upgrade' : '/verification-required');

export const createSessionNavigationGuard = (store) => async (to, from, next) => {
  if (routeHasMeta(to, 'requiresAuth')) {
    let user = store.getters['auth/authUser'];

    if (!user) {
      try {
        await store.dispatch('auth/getAuthUser');
      } catch (error) {
        // The session-loading action normally handles API failures. This protects navigation
        // if another implementation lets the rejection escape.
      }
      user = store.getters['auth/authUser'];
    }

    if (!user) {
      return next({ name: 'Login' });
    }

    if (routeHasMeta(to, 'requiresVerifiedEmail') && !isEmailVerified(user)) {
      return next({ name: 'Verification Required' });
    }

    return next();
  }

  if (routeHasMeta(to, 'requiresVisitor') && store.getters['auth/loggedIn']) {
    return next({ name: 'Home' });
  }

  return next();
};
